/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BasicFile,
    BasicFileFromJSON,
    BasicFileFromJSONTyped,
    BasicFileToJSON,
} from './';

/**
 * 
 * @export
 * @interface FilesystemFile
 */
export interface FilesystemFile {
    /**
     * 
     * @type {string}
     * @memberof FilesystemFile
     */
    readonly path: string;
    /**
     * 
     * @type {string}
     * @memberof FilesystemFile
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof FilesystemFile
     */
    readonly size: number;
    /**
     * 
     * @type {Date}
     * @memberof FilesystemFile
     */
    readonly modificationTime: Date;
    /**
     * 
     * @type {number}
     * @memberof FilesystemFile
     */
    readonly totalSize: number;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    readonly isDir: boolean;
    /**
     * 
     * @type {Array<BasicFile>}
     * @memberof FilesystemFile
     */
    files?: Array<BasicFile> | null;
    /**
     * 
     * @type {string}
     * @memberof FilesystemFile
     */
    parent: string;
    /**
     * 
     * @type {Date}
     * @memberof FilesystemFile
     */
    readonly accessTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof FilesystemFile
     */
    readonly creationTime: Date;
    /**
     * 
     * @type {string}
     * @memberof FilesystemFile
     */
    mode?: string;
    /**
     * 
     * @type {number}
     * @memberof FilesystemFile
     */
    uid?: number;
    /**
     * 
     * @type {number}
     * @memberof FilesystemFile
     */
    gid?: number;
    /**
     * 
     * @type {string}
     * @memberof FilesystemFile
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof FilesystemFile
     */
    group?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    recursive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FilesystemFile
     */
    affinity?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    modeSetuid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    modeSetgid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    modeSetvfx?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    modeUserRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    modeUserWrite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    modeUserExecute?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    modeGroupRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    modeGroupWrite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    modeGroupExecute?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    modeOthersRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    modeOthersWrite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemFile
     */
    modeOthersExecute?: boolean;
}

export function FilesystemFileFromJSON(json: any): FilesystemFile {
    return FilesystemFileFromJSONTyped(json, false);
}

export function FilesystemFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilesystemFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
        'name': json['name'],
        'size': json['size'],
        'modificationTime': (new Date(json['modification_time'])),
        'totalSize': json['total_size'],
        'isDir': json['is_dir'],
        'files': !exists(json, 'files') ? undefined : (json['files'] === null ? null : (json['files'] as Array<any>).map(BasicFileFromJSON)),
        'parent': json['parent'],
        'accessTime': (new Date(json['access_time'])),
        'creationTime': (new Date(json['creation_time'])),
        'mode': !exists(json, 'mode') ? undefined : json['mode'],
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
        'gid': !exists(json, 'gid') ? undefined : json['gid'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'group': !exists(json, 'group') ? undefined : json['group'],
        'recursive': !exists(json, 'recursive') ? undefined : json['recursive'],
        'affinity': !exists(json, 'affinity') ? undefined : json['affinity'],
        'modeSetuid': !exists(json, 'mode_setuid') ? undefined : json['mode_setuid'],
        'modeSetgid': !exists(json, 'mode_setgid') ? undefined : json['mode_setgid'],
        'modeSetvfx': !exists(json, 'mode_setvfx') ? undefined : json['mode_setvfx'],
        'modeUserRead': !exists(json, 'mode_user_read') ? undefined : json['mode_user_read'],
        'modeUserWrite': !exists(json, 'mode_user_write') ? undefined : json['mode_user_write'],
        'modeUserExecute': !exists(json, 'mode_user_execute') ? undefined : json['mode_user_execute'],
        'modeGroupRead': !exists(json, 'mode_group_read') ? undefined : json['mode_group_read'],
        'modeGroupWrite': !exists(json, 'mode_group_write') ? undefined : json['mode_group_write'],
        'modeGroupExecute': !exists(json, 'mode_group_execute') ? undefined : json['mode_group_execute'],
        'modeOthersRead': !exists(json, 'mode_others_read') ? undefined : json['mode_others_read'],
        'modeOthersWrite': !exists(json, 'mode_others_write') ? undefined : json['mode_others_write'],
        'modeOthersExecute': !exists(json, 'mode_others_execute') ? undefined : json['mode_others_execute'],
    };
}

export function FilesystemFileToJSON(value?: FilesystemFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'files': value.files === undefined ? undefined : (value.files === null ? null : (value.files as Array<any>).map(BasicFileToJSON)),
        'parent': value.parent,
        'mode': value.mode,
        'uid': value.uid,
        'gid': value.gid,
        'user': value.user,
        'group': value.group,
        'recursive': value.recursive,
        'affinity': value.affinity,
        'mode_setuid': value.modeSetuid,
        'mode_setgid': value.modeSetgid,
        'mode_setvfx': value.modeSetvfx,
        'mode_user_read': value.modeUserRead,
        'mode_user_write': value.modeUserWrite,
        'mode_user_execute': value.modeUserExecute,
        'mode_group_read': value.modeGroupRead,
        'mode_group_write': value.modeGroupWrite,
        'mode_group_execute': value.modeGroupExecute,
        'mode_others_read': value.modeOthersRead,
        'mode_others_write': value.modeOthersWrite,
        'mode_others_execute': value.modeOthersExecute,
    };
}


